import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t, i18n } = useTranslation('home');
  const isRTL = i18n.language === 'ar';

  return (
    <footer className="py-12 px-6 bg-slate-900 text-white" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Logo & Description - First column (Right in RTL, Left in LTR) */}
          <div className="md:col-span-2">
            <div className={`flex items-center gap-3 mb-4 ${isRTL ? '' : ''}`}>
              <img 
                src="https://customer-assets.emergentagent.com/job_java-mentor-bot/artifacts/o77zmx4s_Gemini_Generated_Image_q1uh1iq1uh1iq1uh.png" 
                alt="FaheemGPT" 
                className="w-12 h-12 rounded-xl"
              />
              <span className="text-2xl font-bold">{t('footer.platformName')}</span>
            </div>
            <p className="text-white/60 leading-relaxed max-w-md">
              {t('footer.description')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-4">{t('footer.quickLinks')}</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-white/60 hover:text-white transition-colors">{t('nav.about')}</Link></li>
              <li><Link to="/partners" className="text-white/60 hover:text-white transition-colors">{t('nav.partners')}</Link></li>
              <li><Link to="/how-it-works" className="text-white/60 hover:text-white transition-colors">{t('nav.howItWorks')}</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-bold text-lg mb-4">{t('footer.legal')}</h4>
            <ul className="space-y-2">
              <li><Link to="/privacy" className="text-white/60 hover:text-white transition-colors">{t('footer.privacy')}</Link></li>
              <li><Link to="/terms" className="text-white/60 hover:text-white transition-colors">{t('footer.terms')}</Link></li>
              <li><Link to="/support" className="text-white/60 hover:text-white transition-colors">{t('footer.support')}</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center text-white/40 text-sm">
          {t('footer.copyright')}
        </div>
      </div>
    </footer>
  );
}
